import { AnimationCallbackEvent, AnimationFunction } from '@angular/core';

/**
 * `animate.leave` in its function form, for the callers that must run something once
 * the exit animation is over — disposing a CDK overlay, chaining the next item.
 *
 * The class form offers no completion hook, and a plain `animationend` listener never
 * fires when the animation is suppressed (`motion-reduce:animate-none`, or a browser
 * with animations off), which would strand the caller's cleanup. Awaiting
 * `getAnimations()` covers both: an element with nothing to play settles immediately.
 */
export function leaveWith(
    classNames: string,
    onDone?: () => void,
): AnimationFunction {
    return (event: AnimationCallbackEvent): void => {
        const target = event.target;
        target.classList.add(...classNames.split(' '));

        void Promise.allSettled(
            target.getAnimations().map((animation) => animation.finished),
        ).then(() => {
            event.animationComplete();
            onDone?.();
        });
    };
}
